export function titleCase(title: string): string {
  const titleWithoutFlex = title.replace('flex-', '');
  return `${titleWithoutFlex.substring(0, 1).toUpperCase()}${titleWithoutFlex
    .substring(1)
    .replace(/_/g, ' ')
    .replace(/-[a-zA-Z]/g, (match) => ` ${match[1]}`)
    .toLowerCase()}`;
}
